<template>
  <div class="avv-view" v-if="userdata && user_info">
    <v-card class="my-4" v-if="!userdata.avv_signed_date">
      <v-card-title class="font-weight-bold">
        Auftragsverarbeitungsvertrag (AVV)
      </v-card-title>
      <v-card-text>
        Sie haben noch keinen AVV abgeschlossen. Hier können Sie einen AVV mit der APJ Sofware UG im Bezug auf die
        Verarbeitung Ihrer Unternehmensdaten in der SODA Webanwendung abschließen.
      </v-card-text>
      <v-card-actions>
        <v-dialog v-model="show_template" width="800">
          <template v-slot:activator="{ on }">
            <v-btn outlined color="primary" v-on="on" v-on:click="update">AVV Abschließen</v-btn>
          </template>
          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
              AVV Abschluss
            </v-card-title>

            <v-card-text v-if="avv_text_html">
              <div v-html="avv_text_html"></div>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-checkbox v-model="avv_read_and_understood" label="Hiermit erkläre ich mich mit dem AVV einverstanden.">
              </v-checkbox>
              <v-spacer></v-spacer>
              <v-btn color="primary" outlined :disabled="!avv_read_and_understood" v-on:click="signAVVTemplate()">
                AVV Unterschreiben
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-actions>
    </v-card>
    <v-card class="my-4" v-if="userdata.avv_signed_date">
      <v-card-title class="font-weight-bold">
        Auftragsverarbeitungsvertrag (AVV)
      </v-card-title>
      <v-card-text>
        Sie haben am {{ userdata.avv_signed_date | moment("LLLL") }} der AVV zwischen Ihnen und der APJ Software UG
        abgeschlossen.
      </v-card-text>
      <v-card-actions>
        <v-btn text v-on:click="downloadAVVPDF()">Abgeschlossenen AVV als PDF laden</v-btn>
        <v-btn v-if="isAdmin" text color="warning" v-on:click="test()">Admin: AVV zurücksetzen</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
const SODA_PUBLISH_TOMS_HASH = "1234567890abdcef1234567890abdcef";
const AVVTextURL = require("file-loader!../assets/AVVText.md");
const md = require("markdown-it")({
  html: true,
  linkify: true,
  typographer: true,
});
const pdfMakeX = require("pdfmake/build/pdfmake.js");
const pdfFontsX = require("pdfmake-unicode/dist/pdfmake-unicode.js");
pdfMakeX.vfs = pdfFontsX.pdfMake.vfs;
import * as pdfMake from "pdfmake/build/pdfmake";

//const htmlToPdfMake = require("html-to-pdfmake");

import htmlToPdf from "../htmlToPdf.js";

import { util } from "./lib/util";
import moment from "moment";

export default {
  name: "AVVView",
  computed: {
    isAdmin() {
      return (
        this.$store.state.originalStore.user_info &&
        this.$store.state.originalStore.user_info.attributes.hasOwnProperty("custom:admin") &&
        this.$store.state.originalStore.user_info.attributes["custom:admin"] === "1"
      );
    },
    user_info: function() {
      return this.$store.state.originalStore.user_info;
    },
    userdata: {
      get: function() {
        return this.$store.state.userdata.value;
      },
      set: function(value) {
        this.$store.dispatch("setUserdata", value);
      },
    },
  },
  mounted() {
    this.update();
  },
  methods: {
    update() {
      if (this.user_info && this.userdata) {
        this.fetchAVVText();
      }
    },
    test() {
      this.userdata.avv_version = null;
      this.userdata.avv_signed_date = null;
      this.updateUserdata();
    },
    updateUserdata() {
      this.userdata = this.userdata;
    },
    signAVVTemplate() {
      this.show_template = false;
      this.userdata.avv_version = 1;
      this.userdata.avv_signed_date = new Date();

      this.generatePDF();
    },
    generatePDF() {
      var docDef = {
        content: htmlToPdf(this.avv_text_html),
        footer: function(currentPage, pageCount) {
          return {
            margin: 10,
            columns: [
              {
                fontSize: 9,
                text: [
                  {
                    text: "--------------------------------------------------------------------------" + "\n",
                    margin: [0, 20],
                  },
                  {
                    text:
                      "Erstellt mit ©SODA - " +
                      moment().format("LLLL") +
                      " - APJSoft UG - Seite " +
                      currentPage.toString() +
                      " von " +
                      pageCount,
                  },
                ],
                alignment: "center",
              },
            ],
          };
        },
      };
      pdfMake.createPdf(docDef).getBuffer((buffer) => {
        this.putPDF("AVV.pdf", buffer);
      });
    },
    putPDF(name, content) {
      this.$eventHub.emit("sync-status-syncing");
      this.$Amplify.Storage.put(name, content, {
        level: "private",
        contentType: "application/pdf",
      })
        .then((result) => {
          this.$eventHub.emit("sync-status-success", {
            entity_type: "AVV Dokument",
            entity_label: "",
            sync_type: "save",
          });
          this.userdata.avv_link = result.key;
          this.finishSigning();
        })
        .catch((err) => {
          this.$eventHub.emit("sync-status-failure", {
            entity_type: "AVV Dokument",
            entity_label: "",
            sync_type: "save",
            error: err.errors[0].message,
          });
        });
    },
    finishSigning() {
      //this.loading = false
      this.updateUserdata();
    },
    downloadAVVPDF() {
      var name = this.userdata.avv_link;
      this.$Amplify.Storage.get(name, { level: "private" })
        .then((result) => {
          util.downloadDataUrlFromJavascript(name, result);
        })
        .catch((err) => console.error("get err", err));
    },
    fetchAVVText() {
      var oReq = new XMLHttpRequest();
      oReq.addEventListener("load", (data) => {
        this.avv_text_md = data.target.responseText
          .replace("{userdata.fullname}", this.userdata.fullname || "Anonymer Nutzer")
          .replace("{user_info.attributes.email}", this.user_info.attributes.email)
          .replace("{signature_name}", this.userdata.fullname || this.user_info.attributes.email)
          .replace("{signature_date}", moment().format("DD.MM.YYYY"))
          .replace("{soda_tom_publish_link}", `app.soda-dsgvo.de/published-measures/${SODA_PUBLISH_TOMS_HASH}`);
        this.avv_text_html = md.render(this.avv_text_md);
      });
      oReq.open("GET", AVVTextURL);
      oReq.send();
    },
  },
  data: function() {
    return {
      show_template: false,
      avv_text_md: null,
      avv_text_html: null,
      avv_read_and_understood: false,
    };
  },
};
</script>

<style lang="stylus" scoped></style>
